import axios from 'axios'
import store from '@/store'
import { STORAGE_KEY } from '@/store/state'

class Emma {
	constructor () {
		let user = null
		if (JSON.parse(window.localStorage.getItem(STORAGE_KEY))) {
			user = JSON.parse(window.localStorage.getItem(STORAGE_KEY)).users
			if (user) {
				this.refresh = user.refresh || null
				this.token = user.token || null
			}
		}
		this.root = process.env.API_ROOT
	}

	post (url, data, type = null) {
		let requestHeader = null
		// Add token
		if (url !== 'api/login' && url.indexOf('api/resetting') === -1) {
			requestHeader = this.getHeader()
		}

		// Add type
		if (type) {
			requestHeader.headers['Content-Type'] = type
		}
		// Add http referer
		if (process.env.SITE === 'client' && (url === 'api/login' || url === 'api/register' || url === 'api/anonymous')) {
			requestHeader = { headers: { HTTP_REFERER: this.getReferer() } }
		}

		console.log('[POST] // API CALL : ', url)
		return new Promise((resolve, reject) => {
			axios.post(this.root + url, data, requestHeader).then((result) => {
				resolve(result)
			}).catch((error) => {
				if (error.response.data.code === 403) {
					this.refreshToken().then(() => {
						this.post(url, data, type).then((result) => {
							resolve(result)
						}).catch((error) => {
							reject(error)
						})
					})
				} else {
					reject(error)
				}
			})
		})
	}
	put (url, data, type = null) {
		let requestHeader = null
		// Add token
		if (url !== 'api/login' && url.indexOf('api/resetting') === -1) {
			requestHeader = this.getHeader()
		}

		// Add type
		if (type) {
			requestHeader.headers['Content-Type'] = type
		}
		// Add http referer
		if (process.env.SITE === 'client' && (url === 'api/login' || url === 'api/register' || url === 'api/anonymous')) {
			requestHeader = { headers: { HTTP_REFERER: this.getReferer() } }
		}

		console.log('[PUT] // API CALL : ', url)
		return new Promise((resolve, reject) => {
			axios.put(this.root + url, data, requestHeader).then((result) => {
				resolve(result)
			}).catch((error) => {
				if (error.response.data.code === 403) {
					this.refreshToken().then(() => {
						this.post(url, data, type).then((result) => {
							resolve(result)
						}).catch((error) => {
							reject(error)
						})
					})
				} else {
					reject(error)
				}
			})
		})
	}
	delete (url) {
		console.log('[DELETE] // API CALL : ', url)
		return new Promise((resolve, reject) => {
			axios.delete(this.root + url, this.getHeader()).then((result) => {
				resolve(result)
			}).catch((error) => {
				if (error.response.data.code === 403) {
					this.refreshToken((url !== 'api/logout')).then(() => {
						this.get(url).then((result) => {
							resolve(result)
						}).catch((error) => {
							reject(error)
						})
					})
				} else {
					reject(error)
				}
			})
		})
	}
	get (url, withToken = true) {
		console.log('[GET] // API CALL : ', url)
		const header = withToken ? this.getHeader() : undefined
		return new Promise((resolve, reject) => {
			axios.get(this.root + url, header).then((result) => {
				resolve(result)
			}).catch((error) => {
				if (error.response.data.code === 403 && withToken) {
					this.refreshToken((url !== 'api/logout')).then(() => {
						this.get(url).then((result) => {
							resolve(result)
						}).catch((error) => {
							reject(error)
						})
					})
				} else {
					reject(error)
				}
			})
		})
	}
	refreshToken () {
		return new Promise((resolve, reject) => {
			console.log('REFRESH TOKEN', this.refresh)
			if (this.refresh) {
				axios.post(this.root + 'api/token/refresh', {
					refresh_token: this.refresh
				}).then((result) => {
					console.log('TOKEN REFRESH SUCCESS')
					this.refresh = result.data.refresh_token
					this.token = result.data.token
					store.commit('TOKEN', { user: result.data })
					resolve()
				}).catch((error) => {
					reject(error)
					store.commit('LOGOUT')
					window.location = '/login'
				})
			}
		})
	}
	getReferer () {
		return process.env.BASE
	}
	setToken (refreshToken, token) {
		this.refresh = refreshToken
		this.token = token
	}
	getHeader () {
		if (this.token) {
			return {
				headers: {
					'X-Auth-Token': 'Bearer ' + this.token
				}
			}
		} else {
			return null
		}
	}
}

const emma = new Emma()

export default emma



// WEBPACK FOOTER //
// ./src/common/services/Emma.js